export default __webpack_public_path__ + "static/media/trash2.b8f6e06f.svg";